import React, { useState, useEffect } from "react";
import "./AccountLocked.css";
import { BASE_URL_APISERVICES } from "../../utils/Constants";
import { RetailerApi_Endpoint } from "../../utils/RetailerApiEndpoint";

const AccountLocked = ({ mobile }) => {
  const [accountData, setAccountData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    checkAccountStatus();
  }, []);

  const checkAccountStatus = async () => {
    try {
      let user = JSON.parse(sessionStorage.getItem("user"));
      setLoading(true);
      const response = await fetch(
        `${BASE_URL_APISERVICES}${RetailerApi_Endpoint.AGENT_LOGIN_MOBILE}`,
        {
          method: "POST",
          headers: {
            "ADMIN-ID": "3",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            mobile: user.mobile,
            capatcha: "N",
          }),
        }
      );

      const data = await response.json();
      setAccountData(data);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const handleContactSupport = () => {
    sessionStorage.removeItem("user");
    window.location.href = "/activate-user";
  };

  const handleTryAgain = () => {
    sessionStorage.removeItem("user");
    window.location.href = "/";
  };

  if (loading) {
    return (
      <div className="account-locked-container">
        <div className="account-locked-card">
          <div className="account-locked-loader">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="account-locked-container">
      <div className="account-locked-card">
        <div className="account-locked-icon">
          <svg
            width="80"
            height="80"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
          </svg>
        </div>

        <h1 className="account-locked-title">Account Locked</h1>

        <p className="account-locked-message">
          Your account has been temporarily locked due to suspicious activity
          detected on your account.
        </p>

        <div className="account-locked-info">
          <h3 className="account-locked-info-title">
            Why was my account locked?
          </h3>
          <ul className="account-locked-list">
            <li>Multiple failed login attempts</li>
            <li>Unusual access patterns detected</li>
            <li>Login from an unrecognized device or location</li>
          </ul>
        </div>

        <div className="account-locked-actions">
          <button
            className="account-locked-btn account-locked-btn-primary"
            onClick={handleContactSupport}
          >
            Activate Account
          </button>
          <button
            className="account-locked-btn account-locked-btn-secondary"
            onClick={handleTryAgain}
          >
            Back to Login
          </button>
        </div>

        <p className="account-locked-footer">
          If you believe this is a mistake, please contact our support team at{" "}
          <a href="mailto:support@bumppy.com" className="account-locked-link">
            support@bumppy.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default AccountLocked;
